import type { Action } from './actions'
import type { MetaShortDTO } from 'shared/types/api'

export type State = {|
    +metaData: ?MetaShortDTO
|}

const initialState: State = {
    metaData: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_TIMELINE_RESPONSE':
            return {
                ...state,
                ...action.data
            }
        default:
            return state
    }
}
